import { ResponseStatusEnum } from "../../../helpers/GlobalEnum";
import { alertedProductsServices } from "../../../helpers/services/AlertedProductsServices";

// Normaliza la respuesta de alertas/titular/?identificacion=<doc> al shape que
// consume la sección "Información del titular" de Centralización. La respuesta
// no incluye la identificación, por lo que se conserva la de la consulta.
const normalizeTitular = (data = {}, identificacion = "") => ({
  nombreCompleto: data?.nombre_completo ?? "",
  identificacion: identificacion ?? "",
  cub: data?.cub ?? "",
  departamento: data?.departamento ?? "",
  municipio: data?.municipio ?? "",
  plan: data?.plan ?? "",
  lineaProductiva: data?.linea_productiva ?? "",
});

// Consulta la información del titular por su identificación. El recurso vive en
// el módulo de alertas (titular/?identificacion=<documento_titular>).
export const getCentralizationTitular = async (documentoTitular) => {
  const response = await alertedProductsServices.getTitular(documentoTitular);

  if (response?.status !== ResponseStatusEnum.OK) {
    throw response;
  }

  const data = response?.data ?? {};
  if (Object.keys(data).length === 0) {
    throw new Error("Titular no encontrado");
  }

  return normalizeTitular(data, documentoTitular);
};